import React from "react";

const MessageIcon = ({ active }) => {
  return (
    <svg
      width="28"
      height="20"
      viewBox="0 0 28 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.9157 0.899998L23.0843 0.9C25.2987 0.9 27.1 2.7013 27.1 4.91592L27.1 15.3766C27.1 17.591 25.2987 19.3925 23.0843 19.3925L4.9159 19.3925C2.70128 19.3925 0.899981 17.5912 0.899981 15.3766L0.899982 4.91591C0.899982 2.7014 2.70112 0.900157 4.91541 0.899998C4.9155 0.899998 4.9156 0.899998 4.9157 0.899998ZM2.32453 15.3764C2.32453 16.8048 3.48705 17.9672 4.91555 17.9672L23.0839 17.9672C24.5124 17.9672 25.675 16.8049 25.675 15.3764L25.6748 4.91567C25.6748 3.48718 24.5122 2.3248 23.0837 2.3248L4.91536 2.32479C3.48686 2.32479 2.32434 3.48713 2.32434 4.91567L2.32453 15.3764Z"
        fill={active ? "white" : "black"}
        stroke="#4E4E4E"
        strokeWidth="0.2"
      />
      <path
        d="M10.567 9.07697L5.26135 5.42164C4.98281 5.22978 4.91275 4.84837 5.10461 4.56979C5.29686 4.29107 5.67828 4.221 5.95646 4.41287L11.8481 8.47218C13.1348 9.35912 14.8644 9.35858 16.1509 8.47237L22.0425 4.41306C22.3213 4.2212 22.7025 4.29107 22.8944 4.56998C23.0862 4.84852 23.0162 5.22996 22.7376 5.42183L17.4325 9.07716L23.112 14.9668C23.347 15.2104 23.3398 15.5979 23.0964 15.8328C22.9772 15.9475 22.8241 16.0044 22.671 16.0044C22.5105 16.0044 22.3503 15.9416 22.2302 15.8171L16.3894 9.76033C15.6479 10.1605 14.8238 10.3607 13.9997 10.3607C13.1755 10.3607 12.3515 10.1605 11.6099 9.76014L5.76914 15.8169C5.64905 15.9416 5.48869 16.0042 5.32833 16.0042C5.17541 16.0042 5.02211 15.9471 4.90299 15.8326C4.65977 15.5978 4.65251 15.21 4.88733 14.9666L10.567 9.07697Z"
        fill={active ? "white" : "black"}
      />
    </svg>
  );
};
export default MessageIcon;
